/* Shared primitives used across YABA sections. */

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`text-[11px] font-medium tracking-[0.22em] uppercase text-[#C8A96A] ${className}`}>
      {children}
    </p>
  );
}

export function SerifH({ children, size = "clamp(40px, 4.2vw, 72px)", className = "", as: As = "h2" }) {
  return (
    <As
      className={`font-normal leading-[1.02] tracking-[-0.015em] ${className}`}
      style={{ fontFamily: "Fraunces, serif", fontSize: size }}
    >
      {children}
    </As>
  );
}
